var exports = {
  "kL": "xe533113f--2d3d4b--container",
  "tX": "xe533113f--2d3d4b--title-container",
  "vM": "xe533113f--2d3d4b--subtitle-container",
  "FR": "xe533113f--2d3d4b--button-container",
};

module.exports = exports;
